// extracted by mini-css-extract-plugin
export default {"columnButtonsContainer":"table_properties-module___columnButtonsContainer___e6dccf86","hr":"table_properties-module___hr___da9cf342"};